/* Booking form + order confirmation. Ported verbatim from templates/ELCAPP.html. */
import { useState, C, Ic, F, Steps } from './common.js';

const BookingForm = ({ setScreen, setOD, sq, setSQ }) => {
  const [f, sf] = useState({ sCo: '', sA1: '', sA2: '', sCity: '', sSt: '', sZip: '', cCo: '', cA1: '', cA2: '', cCity: '', cSt: '', cZip: '', notes: '' });
  const [submitting, setSubmitting] = useState(false);
  const s = (k, v) => sf((p) => ({ ...p, [k]: v }));
  const inp = (label, k, ph, style = {}) => <F label={label} style={style}><input placeholder={ph} value={f[k]} onChange={(e) => s(k, e.target.value)} /></F>;

  const doBook = async (forceFlag) => {
    if (!sq?.quote_ref) { alert('No quote selected.'); return; }
    setSubmitting(true);
    try {
      const resp = await fetch('/api/elcapp/bookings', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          quote_ref:    sq.quote_ref,
          cargo_details: { shipper: f.sCo, consignee: f.cCo, shipper_addr: f.sA1, consignee_addr: f.cA1 },
          notes:        f.notes,
          force:        forceFlag || false,
        })
      });
      const data = await resp.json();
      setSubmitting(false);

      if (data.booking_ref) {
        setOD({
          orderId:  data.booking_ref,
          quoteId:  sq.quote_ref || '—',
          mbl: '—', hbl: '—', shipment: '—', quotedBy: 'ELC Team',
          product:  sq.product  || '—',
          weight:   sq.charge_weight ? `${sq.charge_weight} kg` : '—',
          dims: '—', qty: '—',
          freight:  parseFloat(sq.price) || 0,
          handling: 0, insurance: 0,
          handler: { name: 'ELC Operations', email: 'ops@expresslinecorp.com', phone: '310.645.1355' }
        });
        setScreen('confirmation');
      } else if (resp.status === 410 || data.error === 'quote_expired') {
        alert('This quote has expired. Please request a new quote.');
        setScreen('quote');
      } else if (resp.status === 409 && data.rate_changed) {
        const msg = `Rate has been updated.\n\nOriginal: $${data.old_price?.toFixed(2)}\nUpdated:  $${data.new_price?.toFixed(2)}\n\nProceed with the new price?`;
        if (window.confirm(msg)) {
          await doBook(true);
        }
      } else if (resp.status === 503) {
        // Booking disabled server-side (the create_booking gate). Normally
        // unreachable because the Book buttons are disabled, but defends a
        // stale-state direct submit with the friendly message.
        alert(data.message || 'Booking is not yet available.');
        setScreen('myquotes');
      } else {
        alert(data.message || data.error || 'Booking failed. Please try again.');
      }
    } catch {
      setSubmitting(false);
      alert('Connection error. Please try again.');
    }
  };

  return <div style={{ maxWidth: 820, margin: '0 auto', padding: '36px 20px' }}>
    <Steps cur={2} />
    <h2 className="bc" style={{ fontSize: 30, fontWeight: 700, marginBottom: 22 }}>SHIPMENT BOOKING</h2>
    {sq && <div style={{ background: C.s2, border: `1px solid ${C.brd}`, borderRadius: 8, padding: '12px 20px', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
      <div className="badge b-bl">{sq.product}</div>
      <span className="mono" style={{ fontSize: 14, color: C.green, fontWeight: 700 }}>${parseFloat(sq.price || 0)?.toLocaleString()}</span>
      <span style={{ color: C.textD }}>·</span>
      <span style={{ fontSize: 13, color: C.textM, display: 'flex', alignItems: 'center', gap: 4 }}><Ic.Clock sz={12} />{sq.transit} transit</span>
      {sq.quote_ref && <span className="mono" style={{ fontSize: 11, color: C.textD, marginLeft: 'auto' }}>{sq.quote_ref}</span>}
    </div>}
    <div style={{ display: 'grid', gap: 18 }}>
      {[['Shipper Information', [['Company Name', 'sCo', 'Enter company name'], ['Address Line 1', 'sA1', 'Street address'], ['Address Line 2', 'sA2', 'Suite, floor, etc.']]], ['Consignee Information', [['Company Name', 'cCo', 'Enter company name'], ['Address Line 1', 'cA1', 'Street address'], ['Address Line 2', 'cA2', 'Suite, floor, etc.']]]].map(([title, fields]) =>
      <div key={title} className="card" style={{ padding: 24 }}>
          <div className="sec-hdr">{title}</div>
          <div style={{ display: 'grid', gap: 12 }}>
            {fields.map(([l, k, ph]) => inp(l, k, ph))}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 80px 120px', gap: 12 }}>
              {inp('City', title.startsWith('S') ? 'sCity' : 'cCity', title.startsWith('S') ? 'Los Angeles' : 'Shanghai')}
              {inp('State', title.startsWith('S') ? 'sSt' : 'cSt', title.startsWith('S') ? 'CA' : '—')}
              {inp('Zip', title.startsWith('S') ? 'sZip' : 'cZip', title.startsWith('S') ? '90001' : '200120')}
            </div>
          </div>
        </div>
      )}
      <div className="card" style={{ padding: 24 }}>
        <div className="sec-hdr">Handling Instructions</div>
        <textarea placeholder="Enter any special handling instructions for your cargo..." value={f.notes} onChange={(e) => s('notes', e.target.value)} style={{ height: 90, resize: 'vertical', lineHeight: 1.6 }} />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <button className="btn bo" onClick={() => setScreen('results')}>← Back</button>
        <button className="btn bg" style={{ fontSize: 15, padding: '13px 40px' }} disabled={submitting} onClick={() => doBook(false)}>
          {submitting ? 'PROCESSING…' : 'CONFIRM BOOKING →'}
        </button>
      </div>
    </div>
  </div>;
};

// ── CONFIRMATION ──
// 2026-08 fixes: the legacy screen rendered a hardcoded FICTIONAL booking
// (ORD-67890 / "Jane Smith" / $1,520) to anyone who opened the Tracking tab,
// plus a fake LAX→PVG tracking timeline (there is no tracking backend yet).
// Now: no booking in state → honest empty state; a real booking renders its
// actual refs and financials, without the invented timeline.
const OrderConfirmation = ({ setScreen, od }) => {
  if (!od) return <div style={{ maxWidth: 600, margin: '0 auto', padding: '80px 20px', textAlign: 'center', color: C.textM }}>
    <div style={{ fontSize: 32, marginBottom: 16 }}>📦</div>
    <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>No recent booking</div>
    <div style={{ fontSize: 13, color: C.textD, marginBottom: 24 }}>Book a shipment from a saved quote and its confirmation will appear here.</div>
    <button className="btn bb" onClick={() => setScreen('myquotes')}>My Quotes</button>
  </div>;
  const o = od;
  return <div style={{ maxWidth: 1040, margin: '0 auto', padding: '36px 20px' }}>
    <Steps cur={3} />
    <div style={{ background: 'rgba(16,185,129,0.06)', border: '1px solid rgba(16,185,129,0.18)', borderRadius: 10, padding: '14px 20px', marginBottom: 26, display: 'flex', alignItems: 'center', gap: 14 }}>
      <div style={{ width: 34, height: 34, borderRadius: '50%', background: C.green, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Ic.Check sz={16} col="#fff" /></div>
      <div><div style={{ fontWeight: 700, fontSize: 15, marginBottom: 1 }}>Booking Confirmed!</div><div style={{ fontSize: 13, color: C.textM }}>Your shipment has been booked. Our operations team will follow up with the details.</div></div>
      <div style={{ marginLeft: 'auto', textAlign: 'right' }}><div style={{ fontSize: 9, color: C.textD, textTransform: 'uppercase', letterSpacing: '.1em', marginBottom: 2 }}>Booking Ref</div><div className="mono" style={{ fontSize: 14, fontWeight: 700, color: C.gold }}>{o.orderId}</div></div>
    </div>
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 300px', gap: 20 }}>
      <div style={{ display: 'grid', gap: 18, alignContent: 'start' }}>
        <div className="card" style={{ padding: 22 }}>
          <div className="sec-hdr">Order Information</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            {[['Booking Ref', o.orderId], ['Quote Ref', o.quoteId], ['MBL', o.mbl], ['HBL', o.hbl], ['Shipment #', o.shipment], ['Quoted By', o.quotedBy]].map(([l, v]) =>
            <div key={l}><div style={{ fontSize: 9, color: C.textD, textTransform: 'uppercase', letterSpacing: '.08em', marginBottom: 2 }}>{l}</div><div className="mono" style={{ fontSize: 11, fontWeight: 600, wordBreak: 'break-all' }}>{v}</div></div>
            )}
          </div>
        </div>
      </div>
      <div style={{ display: 'grid', gap: 14, alignContent: 'start' }}>
        <div className="card" style={{ padding: 20 }}>
          <div className="sec-hdr">Financial Summary</div>
          {[['Freight Cost', o.freight], ['Handling Fee', o.handling], ['Insurance', o.insurance]].map(([l, v]) =>
          <div key={l} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: `1px solid ${C.brd}`, fontSize: 13 }}>
              <span style={{ color: C.textM }}>{l}</span><span className="mono">${(v||0).toFixed(2)}</span>
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 0 0', fontWeight: 700, fontSize: 15 }}>
            <span>Total</span><span className="mono" style={{ color: C.green }}>${((o.freight||0) + (o.handling||0) + (o.insurance||0)).toFixed(2)}</span>
          </div>
        </div>
        <div className="card" style={{ padding: 20 }}>
          <div className="sec-hdr">Product Information</div>
          {[['Product', o.product], ['Weight', o.weight], ['Dimensions', o.dims], ['Quantity', o.qty]].map(([l, v]) =>
          <div key={l} style={{ marginBottom: 10 }}>
              <div style={{ fontSize: 9, color: C.textD, textTransform: 'uppercase', letterSpacing: '.08em', marginBottom: 2 }}>{l}</div>
              <div style={{ fontSize: 13, fontWeight: 500 }}>{v}</div>
            </div>
          )}
        </div>
        <div className="card" style={{ padding: 20 }}>
          <div className="sec-hdr">Handling User</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
            <div style={{ width: 32, height: 32, borderRadius: '50%', background: C.s3, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Ic.User sz={13} col={C.textM} /></div>
            <div><div style={{ fontWeight: 600, fontSize: 13 }}>{o.handler.name}</div><div style={{ fontSize: 11, color: C.textM }}>{o.handler.email}</div></div>
          </div>
          <div style={{ fontSize: 12, color: C.textM }}>{o.handler.phone}</div>
        </div>
        <button className="btn bb" style={{ width: '100%' }} onClick={() => setScreen('landing')}>+ New Booking</button>
      </div>
    </div>
  </div>;
};

export { BookingForm, OrderConfirmation };
